<template>
  <span>
    <b-modal id="modal-1" title="Salesforce synchronisatie" hide-footer>
    <b-form @submit.prevent="syncSalesforce">
      <p>Deze actie wordt al dagelijk om 08:00 uur geautomatiseerd uitgevoerd. Om handmatig een extra synchronisatie te starten klik op de 'Start Salesforce Synchronisatie' knop.</p>
      <hr>
      <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
      <b-button type="submit" class="pull-right" variant="success">Start Synchronisatie</b-button>
    </b-form>
  </b-modal>
    <b-button variant="primary" v-b-modal.modal-1>Start Salesforce Synchronisatie</b-button>
  </span>

</template>

<script>

import {getData} from "@/api";

export default {
  name: 'DefaultSalesforceSyncButton',
  methods: {
    async syncSalesforce() {
      const response = await getData('salesforce-sync').then(response => response.data);
      alert(response.message);
      this.closeModal();
    },
    async closeModal() {
      this.$bvModal.hide('modal-1');
    }
  }
}
</script>
